import './components/input-mask';
import JustValidate from 'just-validate';

const validate_budget_plan = new JustValidate('#form-page-budget-planner');

validate_budget_plan.addField('#Income-budget', [{
        rule: 'required',
        errorMessage: 'Field is required',
    },
    {
        validator: (value) => Number(value.replace(/[^0-9.-]+/g, "")) > 0.00,
        errorMessage: 'Number should be more or equal than 0.01',
    },
])
.onSuccess((event) => {
    document.getElementById('form-page-budget-planner').submit();
});

console.log($('#Income-budget').val());

$('#Income-budget').on('keyup', function(){
    if($('#Income-budget').val() == 0.00) {
        $('.form-not-logged .btn-submit').removeClass('btn-toggle-lightbox');
        // $('.form-not-logged .btn-submit').attr('data-lightbox', '');
        $('.form-not-logged .btn-submit').attr('type', 'submit');
    } else {
        // $('.form-not-logged .btn-submit').addClass('btn-toggle-lightbox');
        // $('.form-not-logged .btn-submit').attr('data-lightbox', 'lightbox-login-reminder');
        $('.form-not-logged .btn-submit').attr('type', 'button');
        $('.form-not-logged .btn-submit').on('click', function(e){
            e.preventDefault();
            window.location.href = overviewURL;
            return false;
        })
    };
})
    
if (!page_ajax.user_logged_in) { //if non logged in user go to the page need to save the value first
    var budgetObj = {};
    $("input[type=text]").on("keyup", function() {
        budgetObj[$(this).attr('name')] = $(this).val();
        sessionStorage.setItem("im_budget_wo_login", JSON.stringify(budgetObj));
        setCookie('im_budget_wo_login',JSON.stringify(budgetObj),1);
    });

} else { //user is logged in
    if (sessionStorage.getItem('im_budget_wo_login')) { //get the value from pre-login
        // Retrieve the object from the cache
        var budgetPlan = JSON.parse(sessionStorage.getItem('im_budget_wo_login'));
        $.each(budgetPlan, function(cat, value) {
            $("input[name='" + cat + "']").val(value); //set the value before logged in
        });
    }
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}